function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Speed = /*#__PURE__*/function () {
  function Speed() {
    _classCallCheck(this, Speed);
    _defineProperty(this, "_sampleQueue", []);
    _defineProperty(this, "_speed", 500000);
    _defineProperty(this, "_recentSpeed", 500000);
    _defineProperty(this, "_timer", 0);
    _defineProperty(this, "_dit", 0);
    _defineProperty(this, "_contentLength", 0);
    _defineProperty(this, "_totalByteSize", 0);
    _defineProperty(this, "_speedDown", false);
  }
  _createClass(Speed, [{
    key: "recordLoading",
    value:
    // represent download speed is downward trend

    /**
     * for fetch request
     * @param {Fetch Header} header
     */
    function recordLoading(header) {
      var contentLength = header.get('content-length') || 0;
      var acceptRanges = header.get('Accept-Ranges');
      var contentRange = header.get('Content-Range');
      var partialRequest = !!acceptRanges || !!contentRange;
      if (!contentLength || partialRequest) return;
      this._contentLength = contentLength;

      // calc expceted download time base on avg download speed
      var expcetedTime = Math.floor(contentLength / this._speed * 1000); // ms

      // can downloaded within 50ms
      if (expcetedTime < 50) return;
      this._dit = performance.now();
      this._startTick(contentLength, expcetedTime);
    }
  }, {
    key: "recordLoaded",
    value: function recordLoaded() {
      this._cleanTimer();
      var cost = performance.now() - this._dit; // ms

      this._addSample(Math.floor(this._contentLength / cost));
    }

    // for fetch streaming request
  }, {
    key: "recordChunk",
    value: function recordChunk(byteLength) {
      this._totalByteSize += byteLength;
      this._contentLength += byteLength;
      if (!this._timer) {
        this._dit = performance.now();
        this._startTickForStream();
      }
    }
  }, {
    key: "_startTick",
    value: function _startTick(contentLength, interval) {
      var _this = this;
      this._cleanTimer();
      this._timer = setInterval(function () {
        var cost = performance.now() - _this._dit;
        _this._addSample(Math.floor(contentLength / cost));
      }, interval);
    }
  }, {
    key: "_startTickForStream",
    value: function _startTickForStream() {
      var _this2 = this;
      this._timer = setInterval(function () {
        var cost = performance.now() - _this2._dit;
        _this2._addSample(Math.floor(_this2._contentLength / cost));
        _this2._dit = performance.now();
        _this2._contentLength = 0;
      }, 1000);
    }

    /**
     *
     * for stream: add sample every 1000ms
     * for normal fetch request: add smpale sporadic， depend on donwload speed at that time
     *
     * @param {number} sample  KB/s
     */
  }, {
    key: "_addSample",
    value: function _addSample(sample) {
      this._recentSpeed = sample * 1000;
      if (this._sampleQueue.length > 10) {
        this._sampleQueue = this._sampleQueue.slice(5);
      }
      this._sampleQueue.push(sample);
      this._calcAvgSpeed(this._sampleQueue);
    }
  }, {
    key: "_calcAvgSpeed",
    value: function _calcAvgSpeed(list) {
      var len = list.length;
      var avg = list.reduce(function (all, c) {
        all += c;
        return all;
      }, 0) / len;
      this._speed = Math.floor(avg) * 1000; // B/s
    }
  }, {
    key: "_cleanTimer",
    value: function _cleanTimer() {
      clearTimeout(this._timer);
      this._timer = 0;
    }
  }, {
    key: "clean",
    value: function clean() {
      this._cleanTimer();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      clearTimeout(this._timer);
    }
  }, {
    key: "totalByteSize",
    get: function get() {
      return this._totalByteSize;
    }

    // average speed  (bps)
  }, {
    key: "avgSpeed",
    get: function get() {
      return this._speed * 8;
    }

    // instant speed, there are shaking (bps)
  }, {
    key: "recentSpeed",
    get: function get() {
      return this._recentSpeed * 8;
    }
  }]);
  return Speed;
}();
export { Speed as default };